import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import HeaderNotHome from "../Components/Header/HeaderNotHome";
import DiscordComponent from "../Components/Link/Discord";

function Discord() {
    return (
        <>
        <HeaderNotHome />
        <DiscordComponent />
        </>
      );
}

export default Discord;